import { motion, useReducedMotion } from "framer-motion";
import { Children, type ReactNode } from "react";

interface Props {
  children: ReactNode;
  className?: string;
  delay?: number;
}

export function StaggerGrid({ children, className, delay = 0.04 }: Props) {
  const reduce = useReducedMotion();
  const items = Children.toArray(children);
  return (
    <div className={className}>
      {items.map((child, i) => (
        <motion.div
          key={i}
          initial={reduce ? { opacity: 0 } : { opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.32, ease: [0.2, 0.8, 0.2, 1], delay: i * delay }}
        >
          {child}
        </motion.div>
      ))}
    </div>
  );
}
